import { render, staticRenderFns } from "./myexaminationsixth.vue?vue&type=template&id=bfcbfeb0&scoped=true"
import script from "./myexaminationsixth.vue?vue&type=script&lang=js"
export * from "./myexaminationsixth.vue?vue&type=script&lang=js"
import style0 from "./myexaminationsixth.vue?vue&type=style&index=0&id=bfcbfeb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfcbfeb0",
  null
  
)

export default component.exports